import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Edit } from '@material-ui/icons';
import QuestionTitleField from './QuestionTitleField';

const S = {
  Wrapper: styled.div`
    margin-bottom: 4px;
  `,
  Title: styled.h4`
    display: flex;
    align-items: center;
    min-height: 40px;
  `,
  Content: styled.span`
    padding: 2px 8px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1.25rem;
    font-weight: 400;
    cursor: pointer;
  `,
  Edit: styled(Edit)`
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 1.5rem;
    margin-left: 8px;
    vertical-align: sub;
  `,
};

const QuestionTitle = ({
  children, match, number, onUpdate,
}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(children);

  const showTitleField = useCallback(() => setEditing(true), []);
  const hideTitleField = useCallback(() => setEditing(false), []);
  const handleUpdate = useCallback(() => {
    hideTitleField();

    if (value !== children) {
      onUpdate({
        number, value, prevValue: children, nid: match.params.nid, sid: match.params.sid,
      });
    }
  }, [children, hideTitleField, match.params.nid, match.params.sid, number, onUpdate, value]);
  const handleChange = useCallback(event => setValue(event.target.value), []);
  const handleClear = useCallback(() => {
    hideTitleField();

    setValue(children);
  }, [children, hideTitleField]);

  return (
    <S.Wrapper>
      {editing
        ? (
          <QuestionTitleField
            value={value}
            onChange={handleChange}
            onClear={handleClear}
            onUpdate={handleUpdate}
          />
        )
        : (
          <S.Title>
            <S.Content className="MuiButton-root" onClick={showTitleField}>
              {children}
              <S.Edit />
            </S.Content>
          </S.Title>
        )}

    </S.Wrapper>
  );
};

QuestionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      nid: PropTypes.string.isRequired,
      sid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  number: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default withRouter(QuestionTitle);
